import React from "react";
import { DropdownSelector } from "@Modules/common/Form";
import { readCssVar, getCssKeyName } from "@Utils";
import { IScheduleDropdownProps } from "./ScheduleDropdown";
import useScheduleDropdown from "./useScheduleDropdown";
import styles from "../../../../event.module.scss";

const ScheduleDropdown = (props: IScheduleDropdownProps): JSX.Element => {
    const {
        handleSlotChange,
        options,
        showDropdown,
        isOptionDisabled,
        dropDownValue,
        placeHolder,
        clientSideRendered,
        isMobile,
    } = useScheduleDropdown(props);

    const primaryColor = "#333333";

    const bgColor = "#ffffff";

    const textColor = clientSideRendered
        ? `rgb(${readCssVar(getCssKeyName("rgbColor1-schema1"))})`
        : "#333333";

    const customStyle = {
        menu: (provided: any) => ({
            ...provided,
            zIndex: 15,
            borderRadius: "8px",
            color: primaryColor,
        }),
        container: (provided: { [k: string]: string }) => ({
            ...provided,
            width: "100%",
            minWidth: isMobile ? "200px" : "100px",
        }),
        valueContainer: (provided: { [k: string]: string }) => ({
            ...provided,
            overflow: "visible",
            width: "fit-content",
            display: "inline-flex",
            padding: "4px 16px",
            "& input": {
                height: "0px!important",
            },
        }),
        singleValue: (provided: any) => ({
            ...provided,
            whiteSpace: "unset",
            position: "relative",
            transform: "translateY(0px)",
            maxWidth: "auto",
            top: "unset",
            fontWeight: 500,
            color: !(clientSideRendered && isMobile)
                ? "#333"
                : primaryColor || "#333",
        }),
        control: (provided: any) => ({
            ...provided,
            borderStyle: "solid",
            border: !(clientSideRendered && isMobile)
                ? "1.5px solid #cccccc"
                : `1.5px solid ${textColor || "#212121"}!important`,
            "&:hover": {
                borderColor: !(clientSideRendered && isMobile)
                    ? "#212121"
                    : textColor || "#212121",
                boxShadow: `0 0 0 1px ${
                    !(clientSideRendered && isMobile)
                        ? "#ddd"
                        : primaryColor || "#cccccc"
                }`,
            },
            borderRadius: "8px",
            color: !(clientSideRendered && isMobile)
                ? "#333"
                : textColor || "#333",
            display: "flex",
            padding: isMobile ? "0" : "2px 0 2px 0px",
            backgroundColor: isMobile ? bgColor : "white",
        }),
        placeholder: (provided: any) => ({
            ...provided,
            color: !(clientSideRendered && isMobile)
                ? "#333"
                : primaryColor || "#333",
            position: isMobile ? "relative" : "absolute",
            top: isMobile ? "0" : "50%",
            transform: isMobile ? "none" : "translateY(-50%)",
        }),
        option: (provided: any, { data }: any) => ({
            ...provided,
            ...(data.disabled && {
                textDecoration: "line-through",
                opacity: 0.5,
            }),
            padding: isMobile ? "4px 10px" : "4px 46px 4px 30px",
            fontWeight: 500,
            "&:not(:hover)": {
                backgroundColor: "#fff",
                color: primaryColor,
            },
            "&:hover": {
                ...(!data.disabled && {
                    backgroundColor: `${primaryColor} !important`,
                    color: "#fff",
                }),
            },
        }),
        indicatorSeparator: (provided: any) => ({
            ...provided,
            opacity: 0,
        }),
        menuList: (provided: any) => ({
            ...provided,
            borderRadius: "8px",
            backgroundColor: !(clientSideRendered && isMobile)
                ? "white"
                : bgColor || "white",
        }),
        indicatorsContainer: (provided: any) => ({
            ...provided,
            "& svg": {
                color: isMobile
                    ? `${textColor || "#333"}!important`
                    : "#333!important",
                marginLeft: "0px",
            },
        }),
    };

    return (
        <div className={styles.sectionBody}>
            <div className={styles.recurringClass}>
                {showDropdown ? (
                    "No Classes"
                ) : (
                    <DropdownSelector
                        value={dropDownValue}
                        id="scheduleDropdown-classSchedule"
                        onChange={handleSlotChange}
                        options={options}
                        isOptionDisabled={isOptionDisabled}
                        placeholder={placeHolder}
                        isSearchable={false}
                        name="classSelect"
                        styles={customStyle}
                        design="custom"
                        autoSelect="FIOOO"
                    />
                )}
            </div>
        </div>
    );
};

export default ScheduleDropdown;
